
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404ch2MKbLLFl5U6iOGJg6K4oK7PurWgAk_o0IEFU_45NoV8Meta } from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/404.vue?macro=true";
import { default as error3Rxwy6_45CKivrtANeNBDi3YzlvxT_e9_45of5N_45QwKOxNAMeta } from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/error.vue?macro=true";
import { default as indexFVrAuSBMgCBhVCZuJ6uSznj096RLjBKihiy_45Ku83g3IMeta } from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/index.vue?macro=true";
import { default as logout08HPaDLVrbPOkTf55_z6QwjJj6HH9eDeVahdyb_Z_45hMMeta } from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/logout.vue?macro=true";
import { default as _91threadId_931JAPza90V6h0D3UiiR6t_FopTyv6RMcH4B_kPh0J6TwMeta } from "/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/chat/[threadId].vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404ch2MKbLLFl5U6iOGJg6K4oK7PurWgAk_o0IEFU_45NoV8Meta || {},
    component: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/404.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: { ...(error3Rxwy6_45CKivrtANeNBDi3YzlvxT_e9_45of5N_45QwKOxNAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexFVrAuSBMgCBhVCZuJ6uSznj096RLjBKihiy_45Ku83g3IMeta || {}), ...{"middleware":["auth","course"]} },
    component: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logout08HPaDLVrbPOkTf55_z6QwjJj6HH9eDeVahdyb_Z_45hMMeta || {},
    component: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/logout.vue")
  },
  {
    name: "chat-threadId",
    path: "/chat/:threadId()",
    meta: { ...(_91threadId_931JAPza90V6h0D3UiiR6t_FopTyv6RMcH4B_kPh0J6TwMeta || {}), ...{"middleware":["auth","course"]} },
    component: () => import("/home/runner/work/courserev-chat-web-v2/courserev-chat-web-v2/pages/chat/[threadId].vue")
  }
]